import { ApiConstants } from './constants'

export interface ApiState<Data> { data: Data, error: unknown, loading: boolean }
type ApiStateRecord<Data, StateName extends string> = Record<StateName, ApiState<Data>>
interface SuccessAction<ApiData> { response: ApiData }
interface ErrorAction { error: unknown }

/** @deprecated If using Redux then replace with RTK Query; if using React then replace with Axios, hooks, and context as needed */
export const createApiReducers = <Data, ApiName extends string, StateName extends string>(
  apiActions: ApiConstants<ApiName>,
  dataStateProperty: StateName,
  defaultData: Data,
  willRetrieveErrorObject = false,
  dataTransformer: (data: $TSFIXME, prevData: Data) => Data = data => data,
) => ({
    [apiActions.REQUESTED]: (state: ApiStateRecord<Data, StateName>): ApiStateRecord<Data, StateName> => ({
      ...state,
      [dataStateProperty]: {
        ...state[dataStateProperty],
        loading: true,
      },
    }),
    [apiActions.SUCCESS]: (state: ApiStateRecord<Data, StateName>, action: SuccessAction<Data>) => ({
      ...state,
      [dataStateProperty]: {
        data: dataTransformer(action.response, state[dataStateProperty].data),
        error: null,
        loading: false,
      },
    }),
    [apiActions.FAILURE]: (state: ApiStateRecord<Data, StateName>, action: ErrorAction) => ({
      ...state,
      [dataStateProperty]: {
        data: defaultData,
        // @ts-expect-error TODO: handle `unknown` type properly
        error: willRetrieveErrorObject ? action.error : action.error.message,
        loading: false,
      },
    }),
  })

/** @deprecated If using Redux then replace with RTK Query; if using React then replace with Axios, hooks, and context as needed */
export const createApiReducerInitialState = <StateName extends string, Data>(dataStateProperty: StateName, defaultData: Data, initializedAsLoading = false) => ({
  [dataStateProperty]: {
    data: defaultData,
    error: null,
    loading: initializedAsLoading,
  },
})
